import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import validator from 'validator'
import { useDispatch, useSelector } from 'react-redux'
import { requestAccount } from 'src/redux/apiCalls/authApiCall'
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CardMedia,
  CircularProgress,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material'
import { getMinInstitutionInfo } from 'src/redux/slices/tableSlice/institutionSlice'

const RequestAccount = () => {
  //const { lang } = useSelector((state) => state.language)
  const { minInstitutionData, statusMin, error } = useSelector((state) => state.institution)

  const [login, setLogin] = useState('')
  const [connexion, setConnexion] = useState(false)
  const [formValues, setFormValues] = useState({
    username: {
      error: false,
      errorMessage:
        minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français'
          ? `Votre mail n'est pas valide`
          : 'Your email is not valid',
    },
  })
  const dispatch = useDispatch()

  const handleInputChange = (event) => {
    const { name, value } = event.target
    switch (name) {
      case 'username':
        !validator.isEmail(value)
          ? setFormValues({
              ...formValues,
              [name]: {
                error: true,
                errorMessage:
                  minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français'
                    ? `Votre email n'est pas valide`
                    : 'Your email is not valid',
              },
            })
          : setFormValues({
              ...formValues,
              [name]: { error: false, errorMessage: '' },
            })

        break
    }
    setLogin(value.trim())
  }

  useEffect(() => {
    if (statusMin === 'idle') {
      dispatch(getMinInstitutionInfo())
    }
    if (statusMin === 'succeeded') {
      setConnexion(true)
    } else {
      setConnexion(false)
    }
  }, [dispatch, statusMin])

  function Copyright() {
    return (
      <Grid sx={{ padding: 2 }}>
        <Typography variant="body2" color="textSecondary" align="center">
          {'Copyright © '}
          <Link color="inherit" href="https://universco.fcsdz.com/">
            UNIVERSCO Web App 2024
          </Link>
        </Typography>
      </Grid>
    )
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(requestAccount({ user: login, lang: minInstitutionData?.LANGUE_DEFAUT_ETAB }))
  }

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!connexion || statusMin === 'idle' || statusMin === 'failed'}
        //onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box sx={{ flexGrow: 1 }}>
        <AppBar sx={{ background: '#000000' }} position="static">
          <Toolbar>
            <>
              <CardMedia
                component="img"
                sx={{
                  width: 200,
                  height: 60,
                }}
                image={'/logo_universco.png'}
                alt="Logo"
              />

              <Typography
                sx={{ flexGrow: 1, display: { xs: 'none', lg: 'block', xl: 'none' } }}
                variant="h5"
                component="div"
              >
                {minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français'
                  ? !connexion
                    ? error
                      ? 'Connexion impossible ! Veuillez réessayer...'
                      : 'Connexion à la base de données en cours...'
                    : minInstitutionData?.LIB_ETAB?.length > 90
                    ? minInstitutionData?.LIB_ETAB_C
                    : minInstitutionData?.LIB_ETAB
                  : !connexion
                  ? error
                    ? 'Connection impossible! please try again...'
                    : 'Connection to the current database...'
                  : minInstitutionData?.LIB_ETAB_EN?.length > 90
                  ? minInstitutionData?.LIB_ETAB_EN_C
                  : minInstitutionData?.LIB_ETAB_EN}
              </Typography>
              <Typography
                sx={{ flexGrow: 1, display: { xs: 'block', lg: 'none', xl: 'block' } }}
                variant="h5"
                component="div"
              >
                {minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français'
                  ? minInstitutionData?.LIB_ETAB_C
                  : minInstitutionData?.LIB_ETAB_EN_C}
              </Typography>

              <Button color="inherit">
                <Link
                  to={window.location.origin.replace('teachers-', '')}
                  style={{ textDecoration: 'none', color: 'white' }}
                >
                  {minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français' ? 'Accueil' : 'Home'}
                </Link>
              </Button>
            </>
          </Toolbar>
        </AppBar>
      </Box>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        sx={{ margin: 1 }}
      >
        <Grid item>
          <CardMedia
            component="img"
            sx={{
              //width: parseInt(process.env.REACT_APP_LOGO_WIDTH) || 10,
              height: 80,
            }}
            image={`${process.env.REACT_APP_API_URL}/images/logo_institution.png`}
            alt="Logo"
          />
        </Grid>
      </Grid>

      <Box
        component="form"
        sx={{
          maxWidth: '500px',
          margin: 'auto',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
          backgroundColor: 'white',
          marginTop: 2,
        }}
      >
        <Typography variant="h5" component="div" sx={{ mb: 2 }}>
          {minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français'
            ? `Portail des enseignants - Activer mon compte`
            : 'Teachers portal - Activate my account'}
        </Typography>

        <TextField
          fullWidth
          label={minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français' ? `Email` : 'Mail'}
          margin="normal"
          variant="standard"
          onChange={handleInputChange}
          name="username"
          error={formValues.username.error}
          helperText={formValues.username.error && formValues.username.errorMessage}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2, background: '#000000' }}
          disabled={login === '' || formValues.username.error}
          onClick={handleSubmit}
        >
          {minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français' ? `Activer` : 'Activate'}
        </Button>
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Link to="/login" variant="body2">
            {minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français'
              ? `S'authentifier`
              : 'Authenticate'}
          </Link>
        </Box>
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Link to="/forgot-password" variant="body2">
            {minInstitutionData?.LANGUE_DEFAUT_ETAB === 'Français'
              ? `Mot de passe oublié ?`
              : 'Forgot your password ?'}
          </Link>
        </Box>
      </Box>
      <Copyright />
    </>
  )
}

export default RequestAccount
